import type { FaireProductEntity } from "../../entity_types/product";

export const p_bd5jhepre3: FaireProductEntity = {
  token: "p_bd5jhepre3",
  type: "product",
  name: "Trendy Double Layered Star Pendant Necklace DP26I551",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/9e155e1fd527d67eb84c511075765ce50ef63d453c1c00b3d70700ed85bdaa40.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7eb85a7779b0038fc9a265783c27c10020831e168592afdd770605ed87970e49.jpeg",
    "https://cdn.faire.com/fastly/842d2daa8394c80377f09d9f9e10567d730ff4b20e0d0282ae92646e31ccd3b8.jpeg",
    "https://cdn.faire.com/fastly/c383ee07d55717c427d44d66c348b77fba40ba9ca9b2d43e5452c84a47b66861.jpeg",
    "https://cdn.faire.com/fastly/1f58e50e6aed3497a10961af53adb730f8540fbfd63f2f1a0d13526461de435b.jpeg",
    "https://cdn.faire.com/fastly/22c0ae740ade64dce0f0fbff19a18b3e4330fd1c986b8bfa928947f09d5697be.jpeg",
    "https://cdn.faire.com/fastly/7d404ecafa88246f699aaf563424f21c58967fad004b54e771c962e146c4467d.jpeg",
  ],
  priceDollars: 10.1,
  description:
    "Feature:\n * Trendy, Minimalist\n * Gold Plated\n * Doulble-Layer\n * Cubic Zirconia\n * Star Pendant\n * Lightweight\n * Adjustable\n * Geometric\n * Choker Necklace\n * Simple, Versatile, Delicate \n * Daily Fitting\n * Ideal Gift\n\n Weigh:\n * 10g\n\n Material:\n * Stainless Steel\n\n Package:\n * Package include 1 necklace.\n\n Note:\n * Avoid contact water, perfumes, and chemicals. Store in a dry, cool place and keep away from direct sunlight.\n * Remove before swimming, bathing, or exercising.\n * To clean, gently wipe with a soft, dry cloth. ",
  tags: [],
  msrpDollars: 20.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:57.726Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
